import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const SubpropertyHomePage = () =>
  import('@modules/subproperty/components/subproperty-home-page.vue');
const SubpropertyListPage = () =>
  import('@modules/subproperty/components/subproperty-list-page.vue');
const SubpropertyFormPage = () =>
  import('@modules/subproperty/components/subproperty-form-page.vue');
const SubpropertyViewPage = () =>
  import('@modules/subproperty/components/subproperty-view-page.vue');
const SubpropertyImporterPage = () =>
  import('@modules/subproperty/components/subproperty-importer-page.vue');
const SubpropertyWallet = () =>
  import('@modules/subproperty/components/subproperty-wallet.vue');
const SubpropertyFeeInfo = () =>
  import('@modules/subproperty/components/subproperty-fee-info-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'subproperty',
        path: '/subproperty',
        component: SubpropertyHomePage,
        meta: {
          auth: true,
          permission: Permissions.values.subpropertyRead,
        },
      },
      {
        name: 'subpropertyWallet',
        path: '/subproperty/wallet',
        component: SubpropertyWallet,
        meta: {
          auth: true,
          permission: Permissions.values.subpropertyRead,
        },
        props: true,
      },
      {
        name: 'subpropertyList',
        path: '/subproperty/list',
        component: SubpropertyListPage,
        meta: {
          auth: true,
          permission: Permissions.values.subpropertyRead,
        },
      },
      {
        name: 'subpropertyNew',
        path: '/subproperty/new',
        component: SubpropertyFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.subpropertyCreate,
        },
      },
      {
        name: 'subpropertyImporter',
        path: '/subproperty/import',
        component: SubpropertyImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.subpropertyImport,
        },
      },
      {
        name: 'subpropertyEdit',
        path: '/subproperty/:id/edit',
        component: SubpropertyFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.subpropertyEdit,
        },
        props: true,
      },
      {
        name: 'subpropertyView',
        path: '/subproperty/:id',
        component: SubpropertyViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.subpropertyRead,
        },
        props: true,
      },
      {
        name: 'subpropertyFeeInfo',
        path: '/subproperty/:id/fee',
        component: SubpropertyFeeInfo,
        meta: {
          auth: true,
          permission: Permissions.values.subpropertyRead,
        },
        props: true,
      },
    ],
  },
];
